export default __webpack_public_path__ + "static/media/value3.9bb96635.svg";